import { useEffect, useState } from "react";
import "./App.scss";
// import FormBody from "./Components/FormBody";
import FormIntro from "./Components/FormIntro";
import Header from "./Components/Header";
import IdfcBackground from "./Components/IdfcLetterHead";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import SignIn from "./Components/LoginPage/SignIn";
import Register from "./Components/Register";
// import Help from "./Components/Help";
import Queries from "./Components/Queries";
import { useDispatch, useSelector } from "react-redux";
import MobileSignin from "./Components/LoginPage/MobileSignin";
import Terms from "./Components/Terms";
import { doLogout } from "./Components/LoginPage/redux/actions";
import ErrorBoundary from "./Components/modules/ERcomponent";
import DSPolicy from "./Components/DataSharingPolicy";
import { api } from "./Services";
import { resetState } from "./Components/PersonalInfo/redux/actions";
import { resetIncome } from "./Components/IncomeDetails/redux/actions";
import { resetEdu } from "./Components/Education/redux/actions";
import { resetRegister } from "./Components/Register/redux/actions";
import { resetApp } from "./Components/ApplicationForm/redux/actions";
import { resetQueries } from "./Components/Queries/redux/actions";
import { resetStatus } from "./Components/WelcomeBack/redux/actions";
import { clearDisburse } from "./Components/DisburseForm/redux/actions";
import { resetClear } from "./Components/Connect/redux/actions";
function App() {
  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const dispatch = useDispatch();
  const [unknownUrl, setunknownUrl] = useState(false);
  const [Link, setLink] = useState(
    window.location.href.replace(/^(https?:\/\/)?(www\.)?/i, "")
  );
  const tokenData = useSelector((state) => state.tokens.tokens);
  const [isToken, showToken] = useState(false);
  const getBig = () => {
    let currentUrl = window.location.href.replace(
      /^(https?:\/\/)?(www\.)?/i,
      ""
    );
    let urlList = currentUrl.split("/");
    if (urlList[0] === "https:") {
      urlList = urlList.slice(2);
    }
    console.log("in get url", urlList, Link.slice(2));
    return urlList;
  };

  const getLogout = async () => {
    // const personalInfo = useSelector((state) => state.personal.personalInfo);
    // const dispatch = useDispatch();
    // const tokenData = useSelector((state) => state.tokens.tokens);

    try {
      let users = await api.logout(tokenData.token, personalInfo?.mobile);
      console.log('logout api', users)
      // if (users.statusCode == 200) {
        dispatch(resetState());
        dispatch(resetIncome());
        dispatch(resetEdu());
        dispatch(resetRegister());
        dispatch(resetApp());
        dispatch(resetQueries());
        dispatch(resetStatus());
        dispatch(clearDisburse());
        dispatch(resetClear());
        dispatch(doLogout());
      // }
      // return users;
    } catch (error) {
      console.error("Error logging out:", error);

      //   } finally {
      // setIsLoading(false);
    }
  };

  const logoutMsg = async() => {
    let users=await getLogout();
    console.log('logout api', users)
    console.log("u have been logged out");
  };
  useEffect(() => {
    let newCurrent = window.location.href.replace(/^https?:\/\/(www\.)?/, "");
    // console.log("currentUrl2", newCurrent, newCurrent.split("/"));
    // const cleanedUrl = currentUrl.replace(/^http?:\/\/(www\.)?/, "");
    setLink(newCurrent);
  }, []);
  // useEffect(() => {

  //   let newCurrent = window.location.href.replace(/^http?:\/\/(www\.)?/, "");
  //   console.log("currentUrl2", newCurrent, newCurrent.split("/"));
  //   // const cleanedUrl = currentUrl.replace(/^http?:\/\/(www\.)?/, "");

  useEffect(() => {
    const handleUrlChange = () => {
      setLink(window.location.href.replace(/^https?:\/\/(www\.)?/, ""));
    };

    // Add event listener for popstate (back/forward navigation)
    window.addEventListener("popstate", handleUrlChange);

    // Optionally, you can add event listeners for pushState and replaceState if you're using those
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    window.history.pushState = function (...args) {
      originalPushState.apply(this, args);
      handleUrlChange();
    };

    window.history.replaceState = function (...args) {
      originalReplaceState.apply(this, args);
      handleUrlChange();
    };

    // Clean up event listeners on component unmount
    return () => {
      window.removeEventListener("popstate", handleUrlChange);
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, []);

  useEffect(() => {
    if (tokenData.token) {
      showToken(true);
    } else {
      showToken(false);
    }
  }, [tokenData.token]);

  return (
    <div
      className={`App ${Link.split("/")[1]?.includes("help") && "help"} ${
        isToken ? "not-login" : "login"
      }`}
    >
      <ErrorBoundary>
        <BrowserRouter>
          {!isToken && <Header isLogin={true} />}
          <Routes>
            {/* <Route exact path="/" element={<SignIn />} /> */}
            <Route exact path="/" element={<MobileSignin />} />

            <Route exact path="signup/*" element={<Register />} />
            <Route
              exact
              path="/help"
              element={<Queries isLoggedin={false} />}
            />
            <Route path="terms/*" element={<Terms />} />
            <Route path="policy" element={<DSPolicy />} />

            <Route
              exact
              path="/application/*"
              element={<IdfcBackground logoutMsg={logoutMsg} />}
            />
            {/* <Route element={<MobileSignin/>} /> */}
            <Route
              path="/*"
              element={<MobileSignin setunknownUrl={(e) => setunknownUrl(e)} />}
            />
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
